module.exports = __webpack_public_path__ + "static/media/18-holes-shot-2.19272a2b.jpg";